import React, { Component } from "react";
import Input from "../../components/Input";
import { FaTimes } from "react-icons/fa";
import { observer } from "mobx-react";
import projectStore from "../../stores/projectStore";
import { useNavigate } from "react-router-dom";
import moment from "moment";

function withRouter(Component) {
  return function WrapperComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

const CreateProjectModalV2 = observer(
  class CreateProjectModalV2 extends Component {
    constructor(props) {
      super(props);
      this.state = {
        projectName: "",
        clientName: "",
        projectYear: "",
        errorMessage: "",
      };
      this.modalRef = React.createRef();
    }

    handleChange = (e) => {
      const input = e.target;
      const value = input.value;
      this.setState({ projectYear: value });

      if (!input.validity.valid) {
        this.setState({ errorMessage: input.validationMessage });
      } else {
        this.setState({ errorMessage: "" });
      }
    };

    validateFields = () => {
      const { projectName, clientName, errorMessage } = this.state;

      return (
        projectName.trim() !== "" &&
        clientName.trim() !== "" &&
        errorMessage.trim() === ""
      );
    };

    navigateToProject = (data) => {
      const { projectId, clientName, projectYear, projectName } = data;
      const { navigate } = this.props;

      navigate(`/projects/${projectYear}/${clientName}/${projectId}`, {
        state: { projectName: projectName },
      });
    };

    componentDidMount() {
      const { preselectedClientName, preselectedYear } = projectStore;
      this.setState({
        clientName: preselectedClientName || "",
        projectYear: preselectedYear || "",
      });
      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        projectStore.setCreateNewProjectModalVisibleV2(false);
      }
    };

    handleAddClick = async () => {
      try {
        await projectStore
          .createNewProject(this.state)
          .then((data) => {
            projectStore.setCreateNewProjectModalVisibleV2(false);
            if (this.props.onProjectCreated) {
              this.props.onProjectCreated(data);
            }
          })
          .catch((error) => {
            projectStore.setCreateNewProjectModalVisibleV2(false);
          });
      } catch (error) {
        console.error("Error creating project:", error);
      }
    };

    render() {
      const { projectName, clientName, projectYear, errorMessage } = this.state;

      return (
        <div
          onClick={() => projectStore.setCreateNewProjectModalVisibleV2(false)}
          className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className=" flex relative flex-col w-full lg:w-1/4 h-full lg:h-[55%] py-6 px-5 lg:px-10 bg-white shadow-lg rounded-lg"
          >
            <div className="flex flex-col z-10">
              <h2 className="font-bold text-xl text-[#21272A] pt-2">{`Create New Project`}</h2>
              <div className="flex flex-1 flex-col justify-center">
                <Input
                  title="Year"
                  onChange={this.handleChange}
                  type="number"
                  value={projectYear}
                  required
                />
                {errorMessage && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {errorMessage}
                  </div>
                )}
              </div>

              <div className="flex flex-col lg:flex-row gap-2 mt-2">
                <Input
                  title="Client Name"
                  onChange={(e) =>
                    this.setState({ clientName: e.target.value })
                  }
                  value={clientName}
                />
              </div>
              <div className="flex flex-col lg:flex-row gap-4 mt-4">
                <Input
                  title="Project Name"
                  onChange={(e) =>
                    this.setState({ projectName: e.target.value })
                  }
                  value={projectName}
                />
              </div>

              <div className="mt-4 flex justify-end gap-2 justify-center">
                <button
                  disabled={!this.validateFields()}
                  className={`text-white font-medium text-base px-6 py-2 rounded-md ${
                    this.validateFields() ? "bg-[#130D0D]" : "bg-gray-400"
                  }`}
                  onClick={this.handleAddClick}
                >
                  Create Project
                </button>

                <button
                  onClick={() =>
                    projectStore.setCreateNewProjectModalVisibleV2(false)
                  }
                  className="absolute right-5 top-4"
                >
                  <FaTimes size={20} color="black"></FaTimes>
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);

export default withRouter(CreateProjectModalV2);
